import { userService } from "../services";

const state = {
  items: [],
  item: {},
  loading: true
};

const actions = {
  // get user
  GET_USER({ commit }) {
    commit("requestSent");

    return new Promise((resolve, reject) => {
      userService.getUser().then(
        user => {
          commit("fetchItemSuccess", user.data);
          resolve(user);
        },
        error => {
          commit("requestFail");
          reject(error);
        }
      );
    });
  },

  // get user signature
  GET_SIGNATURE() {
    return new Promise((resolve, reject) => {
      userService.getSignature().then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  // store user signature
  STORE_SIGNATURE({ commit }, options) {
    commit("requestSent");

    return new Promise((resolve, reject) => {
      userService.storeSignature(options).then(
        response => {
          commit("requestFail");
          resolve(response);
        },
        error => {
          commit("requestFail");
          reject(error);
        }
      );
    });
  },

  // get all installers having at least on finalized-work-report
  GET_INSTALLERS({ commit }) {
    commit("requestSent");
    return new Promise((resolve, reject) => {
      userService.getInstallers().then(
        installers => {
          commit("fetchItemsSuccess", installers)
          resolve(installers);
        },
        error => {
          commit("requestFail");
          reject(error);
        }
      );
    });
  }
};

const mutations = {
  // http request sent
  requestSent(state) {
    state.loading = true;
  },
  // http request fails
  requestFail(state) {
    state.loading = false;

  },
  // model
  fetchItemSuccess(state, item) {
    state.loading = false;
    state.item = item;
  },
  // collection
  fetchItemsSuccess(state, items) {
    state.loading = false;
    state.items = items;
  },
};

export const user = {
  namespaced: true,
  state,
  actions,
  mutations
};
